import React from 'react';
import { withRouter } from 'react-router-dom';

import "./wrappedtokens.css";


class Wrappedtokens extends React.Component {

  /*
    tokenSelected
    0 : APIX
    1 : wDASH
    2 : wXZC
  */

  render() {
    return (
      <div className="APIS-wt">

        <div className="APIS-wt-topdiv">
          <div className="APIS-wt-topcontent">
            <div className="APIS-wt-intro">
              <div className="APIS-wt-intro-text">
                <h1 className="APIS-wt-intro-text-head">
                  Core cryptocurrencies of <span className="APIS-wt-intro-text-bold">APIS DeFi Ecosystem</span> -<br/>
                  <span className="APIS-wt-intro-text-bold">APIX</span> & <span className="APIS-wt-intro-text-bold">APIS Wrapped Token</span><br/>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="APIS-wt-centerdiv">
          <div className="APIS-wt-centercontent">

          </div>
        </div>

      </div>
    )
  }
}

export default withRouter(Wrappedtokens);